import Cookies from 'js-cookie';

import { AviosAuthUserSession } from './types';

import { Logger } from '#src/lib/services/Logger.ts';

const DEV_URL = 'https://tst.avios.com';

export async function fetchUser({
  sessionId,
  isLocalhost,
  gatewayUrl,
}: {
  sessionId?: string;
  isLocalhost?: boolean;
  gatewayUrl?: string;
}): Promise<AviosAuthUserSession | null> {
  const opco = Cookies.get('AVIOS_OPCO');
  const sessionCookieName = `${opco?.toLowerCase()}_session_id`;

  try {
    const res = await fetch(`${!isLocalhost ? gatewayUrl : DEV_URL}/auth-gateway/user`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...(isLocalhost && {
          env: 'local',
          [sessionCookieName]: sessionId,
          avios_opco: Cookies.get('AVIOS_OPCO'),
        }),
      },
      // CRITICAL: Ensures HTTP-only session cookies are sent,
      // even if the auth API is on a different subdomain (assuming CORS is configured).
      ...(!isLocalhost && { credentials: 'include' }),
      cache: 'no-store',
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        // Normal state: the user simply isn't logged in.
        return null;
      }
      // Abnormal state: Server error, rate limiting, etc.
      // console.error(`[Auth-Core] Auth fetch failed with status: ${res.status}`);
      // Logger.error(`[Auth-Core] Auth fetch failed with status: ${res.status}`);
      return null;
    }

    const data = await res.json();

    return data || null;
  } catch (err) {
    // Catch network failures, CORS errors, or browser extensions blocking the request
    // console.error('[Auth-Core] Network error during silent auth:', error);
    Logger.error('[Auth-Core] Network error during silent auth', err as Error);
    return null;
  }
}
